import { useEffect, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Modal, Space, Form } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import { CheckImgs } from "../../component/common/Imgs"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 }
}

type fetchParams = {
    store_id: string | undefined,
    check_in_user_name: string | undefined,
    check_in_phone: number | undefined,
    continue_type: number | undefined,
    review_status: number | undefined,
    createDate: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        continue_type: undefined,
        review_status: undefined,
        createDate: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [form] = useForm()
    const [visibled, setVisibled] = useState<boolean>(false)
    const [recordsID, setRecordsID] = useState<string>()

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'createDate', ['create_start_date', 'create_end_date'])

        axiosTable.get('/keeper/customer_continue/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 入住管理 -> 续住管理 */}
        <BreadCrumb position={['管家中心', '续住管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => {
                        handleChange(value, 'store_id')
                    }} value={fetchOtherParams.store_id} />
                </div>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="入住人姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="入住人手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="续住类型" value={fetchOtherParams.continue_type} onChange={(v: number) => { handleChange(v, 'continue_type') }}>
                    <Option value={1} key={1}>自费续住</Option>
                    <Option value={2} key={2}>客诉续住</Option>
                    <Option value={3} key={3}>赠送续住</Option>
                </Select>

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核状态" value={fetchOtherParams.review_status} onChange={(v: number) => { handleChange(v, 'review_status') }}>
                    <Option value={0} key={0}>待审核</Option>
                    <Option value={1} key={1}>审核通过</Option>
                    <Option value={2} key={2}>审核不通过</Option>
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["创建开始日期", "创建结束日期"]} value={fetchOtherParams.createDate} onChange={(v: any) => { handleChange(v, 'createDate') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {<Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="入住门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column fixed title="客户姓名" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column fixed title="客户手机号" dataIndex="check_in_phone" key="check_in_phone" />

                <Column title="续住类型" dataIndex="continue_type_desc" key="continue_type_desc" />
                <Column title="续住天数" dataIndex="continue_days" key="continue_days" />
                <Column title="续住凭证" dataIndex="continue_prov_pic_list" key="continue_prov_pic_list" render={(v: any) => {
                    return <Button onClick={() => {
                        setUrls(v)
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />
                <Column title="续住备注" dataIndex="remark" key="remark" />

                <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />
                <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />

                <Column title="操作" render={(row: any) => {
                    if (row.review_status == 0) {
                        return <Space>
                            <Button size="small" onClick={() => {
                                setRecordsID(row.continue_id)
                                setVisibled(true)
                            }}>审核</Button>
                        </Space>
                    } else {
                        return null
                    }
                }} />
            </Table>
        </div>

        {/* 管家中心 -> 入住管理 -> 续住管理 -> 查看凭证 */}
        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

        {/* 管家中心 -> 入住管理 -> 续住管理 -> 审核 */}
        <Modal title="续住审批" visible={visibled} onCancel={() => { setVisibled(false) }} onOk={() => {
            baseAxiosComplete.post('/keeper/customer_continue/review', {
                continue_id: recordsID,
                review_status: form.getFieldValue('review_status'),
                review_refuse_reason: form.getFieldValue('review_refuse_reason')

            }).then(res => {
                if (res.status == 0) {
                    setVisibled(false)
                    fetch({ pagination: pagination, fetchOtherParams: fetchOtherParams })
                }
            })
        }}>
            <Form form={form} {...formItemLayout}>
                <Form.Item label="是否通过" name="review_status" required>
                    <Select>
                        <Option value={1} >审核通过</Option>
                        <Option value={2} >审核不通过</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="备注（不通过原因）" name="review_refuse_reason" required >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}